import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiModalModule } from '../../../../../shared/components';
import { CommonModule } from '@angular/common';

@Component({
  template: `
    <app-si-dialog #dialogComponent header="Turn Off Sync Data" saveButtonText="Continue"
                   (save)="dialogComponent.onClose(true)">
      <ng-template appDialogBody>
        <div class="py-12">
          <div class="flex flex-wrap -mx-2 gap-0">
            <div class="flex-none w-2/3 ml-[16.666667%] px-2">
              <p class="mb-0">
                Disabling this feature will delete your synced data. In order to get your data back you will need to
                re-connect and wait for your data to load again.
              </p>
            </div>
          </div>
        </div>
      </ng-template>
    </app-si-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SiModalModule,
  ],
  standalone: true,
})
export class SalesforceSyncDataForSearchingComponent {}
